<template>
  <base-layout current="alerts"> 
    <span class="text-h4">Alerts</span>
  </base-layout>
</template>

<script>
import BaseLayout from "@/layouts/BaseLayout.vue";
export default {
  components: {
    BaseLayout,
  },
};
</script>